import React, { Component } from 'react'
import Constants from 'common/constants'
import { withRouter } from 'react-router-dom'
import AccountProvider from 'common/providers/AccountProvider'
const InvitePage = class extends Component {
  static displayName = 'InvitePage'

  constructor(props, context) {
    super(props, context)
    this.state = {}
    AppActions.acceptInvite(this.props.match.params.id)
  }

  componentDidMount = () => {
    API.trackPage(Constants.pages.INVITE)
  }

  onSave = (id) => {
    AppActions.selectOrganisation(id)
    this.props.history.replace(Utils.getOrganisationHomePage(id))
  }

  getErrorMessage(error) {
    switch (error) {
      case 'No Invite matches the given query.':
      case 'Not found.':
        return 'We could not validate your invite, please check the invite URL and email address you have entered is correct.'
      case 'Please upgrade your plan to add additional seats/users':
        return 'The organisation you have been invited to has no seats available. Please contact the organisation administrator to resolve this before trying again.'
      default:
        return error
    }
  }

  render() {
    return (
      <div className='app-container'>
        <AccountProvider onSave={this.onSave}>
          {({ error }) => (
            <div className='centered-container'>
              <div>
                {error ? (
                  <div>
                    <h3 className='pt-5'>Oops</h3>
                    <p>{this.getErrorMessage(error)}</p>
                  </div>
                ) : (
                  <Loader />
                )}
              </div>
            </div>
          )}
        </AccountProvider>
      </div>
    )
  }
}

InvitePage.propTypes = {
  history: RequiredObject,
  location: RequiredObject,
  match: RequiredObject,
}

export default withRouter(InvitePage)
